if (!customElements.get('yimi-recently-viewed')) {
  customElements.define(
    'yimi-recently-viewed',
    class YimiRecentlyViewed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';
        this.loadProducts();
      }

      async loadProducts() {
        const section = this.closest('.shopify-section');
        const currentProductId = Number(this.dataset.excludeId || 0);
        const limit = Number(this.dataset.limit || 4);

        try {
          const storedIds = JSON.parse(localStorage.getItem('yimi:recently-viewed-products') || '[]');
          const ids = [...new Set(storedIds.map(Number))]
            .filter((id) => id && id !== currentProductId)
            .slice(0, limit);

          if (!ids.length) {
            section?.remove();
            return;
          }

          const query = ids.map((id) => `id:${id}`).join(' OR ');
          const searchUrl = this.dataset.searchUrl;
          if (!searchUrl) throw new Error('Recently viewed search URL is missing');

          const url = `${searchUrl}?type=product&q=${encodeURIComponent(query)}&section_id=${this.dataset.sectionId}`;
          const response = await fetch(url, { priority: 'low' });
          if (!response.ok) throw new Error(`Recently viewed request failed: ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const source = html.querySelector('yimi-recently-viewed');
          if (!source || source.children.length === 0) {
            section?.remove();
            return;
          }

          this.replaceChildren(...document.importNode(source, true).childNodes);
        } catch (error) {
          section?.remove();
        }
      }
    }
  );
}
